import angular from 'angular';
import Logger from '../../../shared/logger';

export const OfficeService = (Restangular) => {
    const getOfficeGroups = function () {
        return Restangular.all('office')
            .all('group')
            .get('')
            .catch(error => Logger.error(error));

    };

    const getOffices = function () {
        return Restangular.all('office')
            .get('')
            .catch(error => Logger.error(error));
    };

    return {
        getOfficeGroups,
        getOffices,
    };
};

angular.module('TALENYA-FE')
    .factory('OfficeService', OfficeService);
